module.exports = __webpack_public_path__ + "img/North-Macedonia.f5789d8c.png";